import React from 'react';
import { getPhoneRule, sanitizePhoneInput } from '../../utils/bridgeStaff';
import CountryCodeSelect from './CountryCodeSelect';

export default function PersonFields({
  person,
  onChange,
  bridgeCountry,
  companyCountry,
  showCountryCode = true,
  readOnly = false,
}) {
  const phoneRule = getPhoneRule(person.countryCode);

  return (
    <>
      <div className="form-group">
        <label>Name</label>
        <input
          type="text"
          value={person.name}
          placeholder="Enter full name"
          readOnly={readOnly}
          disabled={readOnly}
          onChange={(e) => onChange({ ...person, name: e.target.value })}
        />
      </div>
      <div className="form-group">
        <label>Email</label>
        <input
          type="email"
          value={person.email}
          placeholder="Enter email"
          readOnly={readOnly}
          disabled={readOnly}
          onChange={(e) => onChange({ ...person, email: e.target.value })}
        />
      </div>
      {showCountryCode && (
        <div className="form-group staff-code">
          <label>Country Code</label>
          <CountryCodeSelect
            value={person.countryCode}
            bridgeCountry={bridgeCountry}
            companyCountry={companyCountry}
            person={person}
            onChange={onChange}
            disabled={readOnly}
          />
        </div>
      )}
      <div className="form-group">
        <label>Phone Number</label>
        <input
          type="tel"
          inputMode="numeric"
          maxLength={phoneRule.length}
          value={person.phone}
          placeholder="Enter phone number"
          readOnly={readOnly}
          disabled={readOnly}
          onChange={(e) =>
            onChange({ ...person, phone: sanitizePhoneInput(e.target.value, person.countryCode) })
          }
        />
      </div>
    </>
  );
}
